import type { PatientAttachment, PatientAttachmentDTO } from '../types';

export const parsePatientAttachmentForFE = (data?: PatientAttachmentDTO): PatientAttachment | null =>
  data ? { id: data.id, fileName: data.file_name, fileUrl: data.file_url } : null;
